<template>
  <section>
    <canvas id="BackCanvas"
      :style="{ width: isMobile ? `${mobileWidth}px` : '100vw', height: isMobile ? `${mobileHeight}px` : '100vh' }"></canvas>
    <div class="box"
      :style="{ width: isMobile ? `${mobileWidth}px` : '100vw', height: isMobile ? `${mobileHeight}px` : '100vh', overflowX: mobileWidth ? 'auto' : 'hide', position: mobileWidth ? 'absolute' : 'fixed' }">

      <div class="container">
        <header>
          <div class="address">{{ currentWeathre.city || orgid == '1013'?'深圳市':'清远市' }} {{ currentWeathre.weather }}
            {{ currentWeathre.temperature }}°C</div>
          <div class="title" v-if="orgid == '1013'">
            <p>国家OID全息种植数字化平台</p>
          </div>
          <div class="title" v-else>
            <p>国家OID农副产品溯源数据平台</p>
            <p>(乡村振兴农特优品展销中心)</p>
          </div>
          <div class="date">{{ currentDate }}</div>
          <!-- 2024年04月24日 21:15:24 星期三 -->
        </header>

        <div class="flex-row content gap6">

          <!-- 左 -->
          <div class="left flex-column gap6">

            <!-- 企业信息模块 -->
            <div class="main-head">企业信息</div>
            <div class="main-box" style="height: calc(50% - 20rem - 11px)">
              <div class="main-content srcoll-box srcoll-auto" style="padding: 0;">
                <K-Table v-if="orgid != '1013'" :data="tableObj" />
              </div>
            </div>

            <!-- 库存信息模块 -->
            <div class="main-head">库存信息</div>
            <div class="main-box" style="height: calc(50% - 20rem - 11px)">
              <div class="main-content srcoll-box srcoll-auto" style="padding: 0;">
                <K-Table v-if="orgid != '1013'" :data="stockTableObj" @itemClick="itemClickHandle" />
              </div>
            </div>

          </div>

          <!-- 中 -->
          <div class="middle flex-column gap6">

            <!-- 块级统计模块 -->
            <div class="flex-row gap6" style="height: 13%;">
              <div class="main-box" :style="{ width: `${(100 / orgInfo.customize_data.length).toFixed(2)}%` }"
                v-for="(item, index) in orgInfo.customize_data" :key="index">
                <div class="main-content style-Illidan">
                  <div class="item item-center">
                    <p class="title">{{ item.key }}</p>
                    <p class="text mt2" :class="item.color">
                      <span class="number">{{ item.value }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 地图模块 -->
            <div class="main-box" style="height: 87%;">
              <div class="main-content">
                <div class="product">
                  <img src="https://zlua.com:9292/pic/清远鸡备份_3.png">
                  <p class="title">清远鸡</p>
                </div>
                <div class="full-box" id="map"></div>
              </div>
            </div>
          </div>

          <!-- 右 -->
          <div class="right flex-column gap6">

            <div class="main-head flex-row align-center">
              <div style="width: 30rem;">视频监控</div>
              <div style="width: calc(100% - 30rem);">
                <!-- <el-select
                  v-model="selectVal"
                  filterable
                  @change="selectChange"
                  placeholder="输入名称搜索"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in this.tableObj.list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select> -->

                <!-- 企业名称模块 -->
                <el-dropdown trigger="click" @command="selectChange" placement="bottom-start">
                  <span class="el-dropdown-link flex-row align-center space-between">
                    <div class="one-line">「{{ selectVal }}」</div>
                    <el-icon class="el-icon-arrow-down"></el-icon>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item :class="selectVal === item.name ? 'el-dropdown-menu__active' : ''"
                        :command="item.id" v-for="item in tableObj.list">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

              </div>
            </div>

            <template v-if="device.length">
              
              <!-- 设备列表 -->
              <div class="main-box" style="height: 10%;">
                <div class="main-content flex-row srcoll-auto">
                  <ul class="btn-array gap10" style="margin: auto 3rem;">
                    <li class="btn" @click="deviceIndex = index" :class="{ 'btn-active': deviceIndex == index }"
                      v-for="(item, index) in device">{{ item.name }}</li>
                  </ul>
                </div>
              </div>
              
              <!-- 企业块级 -->
              <div class="flex-row flex-wrap gap6" style="height: 15%;">
                <div class="main-box" style="width: calc(33.33% - 6px);"
                  v-for="item in device[deviceIndex].customize_data">
                  <div class="main-content style-Illidan">
                    <div class="item item-center">
                      <p class="title cyan-color" style="font-size: 6rem;">{{ item.key }}</p>
                      <p class="text cyan-color mt2">
                        <span class="value">{{ item.value }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 视频播放 -->
              <div class="main-box" style="height: 45%;">
                <div class="main-content">
                  <div class="full-box absolute-box" style="padding: 5px;">
                    <div class="video-box full-box" @click="live.tabObj.index=1;live.isShow = true;">
                      <img class="full-img object-fit-cover" :src="device[deviceIndex].img" />
                      <img class="video-play-icon"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAACMBJREFUeF7tnHtQk1cWwM+XmBeQ1IVBBCoCYjo+gML62KlSUepY1ufS4tTdcUq16zJWt1MrIDQ8pRTB6rggZW2xMFQtYmNVEBhEsIAroyOFgI9AeQR5iQRJAiGBJDs3S1CQx5eQhND9vj/h3nPP9/tuzj33nHsPBkZ8/P39yX+weX0pi8V0YNBpNoPyIWcShtmQSBgdI5Opc0gkClJnSKkcVCkUcqVSNaBUqTop1DkN0gFZp0gkFvR0PnmQnZ2tMJbamKEHCti/f76tpfVbKiB5UmlUNgZA6+4WQrdQCMJuIQifP4cBqQzkg3KQy+VqdahUKlApVKAzaGA5dy5YWlmClaUlWFlZggpAJpfJ+Rgo77cLu26np6R0GPIdDAIoICCAbmXjsI5CI/swaAx2V1cXVt/QCE2CZhA0t6ph6PIgaA4L7cHRYSG4ODuBtbW1SiqT8gdliqLuTsGt9PT0AV3kTtZHr4B2795tbrdg0VY6nbpVOiCz4NU+gOqaWujsfKpvvdXybGzmgdvyZeC6bCkw6DTJwID8WlvLb9cyMzP79DWgXgB5e3vPWbHa630zC7MdIpGIUX67Aqp5taBQGsdUkElkcHNdBmveWg0sFkvaL+n/+V5F6aWSkpKh6YKaNqCDh454vMZi/kMmG7AtKv4FamofglKlnK5eOvUnYSRYvmwJ+Kx/G2g0enuvSPzvpBPxlToJG+6kMyBfX1/aco+VgeZmZuvv3r2PFf9SprNtmc4LjNcX2ar1b6+FlSs9VX39/cU1lXdT8/LyZLqMoxOgffv+6WBjNz9I3Cd24F7OgbaOdl3GNngfu/m24PeXLcA0Zwo62zoSz5z5l0DbQbUG9FnwFyuYTItgfl0dLSc3HwZkuq1I2iqqa3s6jQpbNr8L7MWLZWKxJOFkwpf3tJGlFaBDwWE+LBbrk1ulZeTS8jvajDPjbb3W/AnWea1ViESi0ycS4orwKoQb0OfBnB1MlkVAbl4BVlnFwyvfpNp5uLvCZt9NKrFIkv51QuzPeJTDBWh45hzkcq9iD/h8PHJNts1SNhv8/LapRCJREp6ZNCUgZHNeYzHDcvMKyLN15oz9WsMzSdErEsdNZZMmBYRWq/kLbI+XlpXTZpvNmWoKI5vktXaNrKOl/fBkq9uEgJCfs2K11/G6hnqHS9yrU403K///vt82WOzsIrhXUXp4Ij9pQkBBYRGfDg4ObvjubIbJL+W6fh3kAny850OgUCg3E+NiTo0nZ1xAaPtgZTk38mz6OcxUnUBdoYzth5zJPQF/U3ULn0ePty15BRDaeK713phcWVllW1B0U196mLScTT4bwMPDvb2spPDA2A3uK4AOh4R/gJFg1+nUNJPZWxmaLtq7fRK4F1RKuHD82NEfXx5vFCAUz3FiL03Lyc1noDjO/9OD4kpbNr8rbeQ/2PtyPGkUoJCwqA9kg7JdKalpMxaymKmPgkIl+wP3Ao1Cu3AsLmpkFo0AQmHShc7stOsFNywqq6oNqufO93ZYY0CCrJ+4XQYdSEvhHu5u8OdN70iaG/h7NeHbEUCfh0RsIpOx/aeSUw0aCXyDvZh+OStzFYZhUMWr6QkKjXjc8qTVJEICKDL56YFAUChUKV8fiylAfEcAHYmITqiqqnmjsKhYS+7aNV/1R0+LjLRvPDW9JJL+oZNJp+vOZ10yidm00Wc9uLsvfxwfExk8AgilZpzsHVPPnE3HDBVg1wAZC0jz97LyO12hEdF1z7qF044ja/fJRrdGiYB9ewJUja1NgSilpJ5BoZxIP7Gk/8PU776fjmxcfScChDr39PTKYuMT+dcLCntwCTNQo8CPPwKmhVnGV7HRXDWgI5zo2F+rea43bpYYaMgXYicDhFqpVCrIyy9si4yNb5D09c1I9P+dDd7wppsrLz42koOhdPASN88LF7O5NJTcM/QzFSDN+O3tHVJOVNyj2xUVYkPrNFY+Skru9PeTPay+vwvbd+AzV1ubebGJJ5KM4jnjBYSUViiVqouXuIL4hJMC+dCQyligkGcddOggtHc+5WCHQjlb5FLZ341hf9ALagNIA6ShoVlyJDzyEa/2Yb+xICE7RDdjnMHCY77cU1/fsD2be8UoY+sCCCkml8uVaek/NCZ/822rMRKT/n7bwcXF+QqGDHRl5a+uRbdKTRqQRjleTe3z4C+iHjc1C3RKBOJ9SZ91XuDh8SYPCwuP+bbwZvE8Y8WbdZ1BL79YX5906FRKan3muR8NcyoCAFDceuOG9U8xTtTRzCtX81gPjZSt0AcgDaz/3Ln7LIQTze961qV353IJmw3bt/mKsPCYuKyL2Vz6b41NeGfftNrpE5DaueztlcfFn+Dn5OULp6XYmM6LnBzRUj+ARcfGc7/PPE9+0tqmT/kTytI3II1zGRQazsvN158H/rq9HXy0+68KNaD0zPPkFgLQqI+6wN4OAhCg2f4T6+3tlcca8ifGiTyaeeUaYaTH2gS1kd7qK5qdy7xUOpSUnFqfYYxlnnAUx19PRhzFWbXVyPihMTnFyFsNYrM6/gwa2awS4Y5XAY0Kd4wEzH7i0urrTShg1tEhDY+Ke1R+ZwYCZi5OsPO94YAZ4mdyIdeCG22RR78yjZArAmRSQftjifzretwy6LJ/eiVoT6R9XmAcN+2j/pkRiUM1pXETh+gfxko9L3JypOdczlqFxkSp55DQqMfNT1pMP/Vs7MMLlDkU7FxWtsEigrrYnkkPLyCBxPGXSY6/IEDEAaopDlAhSMQRvEmO4CFAxCHO0bcUiWPA2h4D1lh/4iD5/0gQVxF0vYqA6BGXWSaZQZqfGnEdCofLSVyowwGJuJKJAxJxqRcHJOJaOA5IRGEBHJCI0hQ4IKEmRHETHKCI8jg4IGniSUSBJRywJizR1dQMgpZpluhaYA+OjrO0RNd47LQp8iYbLvJG+70XeZtokmnKBFowzReaMxjzRsoEkjE6RhpTJlCpkCsVL8oE9kmlTyXivmZjlwn8Lz9q5+FNe0ZqAAAAAElFTkSuQmCC" />
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- 设备内容为空 -->
            <div class="main-box" style="height: 70%;" v-else>
              <div class="main-content">
                <K-Transition v-if="!isLoding" middle :customStyle="{ color: '#24e9ea', opacity: .7 }"
                  errorImg="/static/images/error.svg" subHint="暂无数据" />
              </div>
            </div>

            <!-- 出库模块 -->
            <div class="main-head">出库数据「{{ currentYear }}」</div>
            <div class="main-box" style="height: 30%;">
              <div class="main-content" id="sold"></div>
            </div>

          </div>

        </div>
      </div>

    </div>

    <!-- 监控弹出层 -->
    <el-dialog top="5vh" :width="isMobile ? (mobileWidth * 0.8) + 'px' : '80%'" :modal-append-to-body="false"
      :visible.sync="live.isShow" destroy-on-close class="dialog-Alsace" :class="!isMobile ? 'dialog-Alsace-height' : ''">

      <div class="flex-row dialog-head" :style="{ height: isMobile ? mobileWidth * 0.07 + 'px' : '7vh' }">
        <div class="dialog-title" :style="{ lineHeight: isMobile ? mobileWidth * 0.07 + 'px' : '7vh' }">
          溯源中心
        </div>
        <i class="close-icon el-icon-circle-close" @click="live.isShow = false"></i>
      </div>

      <div class="flex-row dialog-main">
        <div class="left">
          <div class="head">监控列表</div>
          <div class="main">
            <ul class="row no-select hover" @click="deviceIndex = index; getBusinessDeviceRecordList();"
              :class="{ 'active': index === deviceIndex }" v-for="(item, index) in device" :key="index">
              <i class="icon el-icon-video-camera"></i>
              <li>{{ item.name }}</li>
              <li>{{ item.device_id }}</li>
            </ul>
          </div>
        </div>
        <div class="right">
          <div class="head">
            <ul class="flex-row no-select">
              <li @click="propsTabsClick(index)" :class="{ 'active': index === live.tabObj.index }"
                v-for="(item, index) in live.tabObj.list" v-if="device.length || index > 1" :key="index">{{ item }}</li>
            </ul>
          </div>
          <div class="main">

            <!-- 实时监控 -->
            <template v-if="live.tabObj.index === 0">
              <div style="width: 450rem;height: 229rem">
                <K-Live v-if="device[this.deviceIndex].url && live.isShow" :data="device[this.deviceIndex]" />
                <template v-else>
                  <K-Transition v-if="!isLoding" :customStyle="{ margin: '30rem auto', color: '#24e9ea', opacity: .7 }"
                    errorImg="/static/images/error.svg" subHint="设备不在线" />
                </template>
              </div>
            </template>

            <!-- 溯源记录 -->
            <template v-if="live.tabObj.index === 1">
              <div class="main-head nobg"><i class="el-icon-timer"></i> 时间轴</div>

              <div style="width: 300rem;height: 153rem;margin:5rem auto;overflow: hidden;">
                <div class="video-box swiper-container" style="width: 100%;height:100%"
                  v-if="device.length && deviceRecord.length">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" @click="liveIsPlay = !liveIsPlay;" v-for="(item, index) in deviceRecord"
                      :key="index">
                      <img class="full-img" :src="item.img" />
                    </div>
                  </div>
                  <img v-if="!liveIsPlay" @click.stop="liveIsPlay = !liveIsPlay;" class="video-play-icon"
                    src="data:image/png;base64,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" />
                </div>

                <div class="no-select" v-else>
                  <K-Transition v-if="!isLoding" :customStyle="{ margin: '30rem auto', color: '#24e9ea', opacity: .7 }"
                    errorImg="/static/images/error.svg" subHint="暂无数据" />
                </div>
              </div>

              <div class="main-head nobg"><i class="el-icon-set-up"></i> 溯源记录</div>
              <viewer @inited="inited" ref="viewer">
                <div class="flex-row list">
                  <template v-if="deviceRecord.length">
                    <ul v-for="(item, index) in deviceRecord" :key="index" class="row">
                      <li>{{ item.created_at }}</li>
                      <li @click="PreviewImgs"><img class="img-box" :src="item.img" /></li>
                    </ul>
                  </template>
                  <div class="full-box no-select" v-else>
                    <K-Transition v-if="!isLoding" middle
                      :customStyle="{ margin: '30rem auto', color: '#24e9ea', opacity: .7 }"
                      errorImg="/static/images/error.svg" subHint="暂无数据" />
                  </div>
                </div>
              </viewer>
            </template>

            <!-- 溯源记录 -->
            <template v-if="live.tabObj.index === 2">
              <div class="main-box">
                <div class="main-content srcoll-box srcoll-auto" style="padding: 0;">
                  <K-Table :data="siteStock" />
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>

    </el-dialog>

  </section>
</template>

<script>
var echarts = require('echarts')
import axios from 'axios'
import Table from '@/components/common/Table.vue'
import Live from '@/components/common/Live.vue'
import Transition from '@/components/common/Transition.vue'
export default {
  name: 'HomePage',
  components: {
    'K-Table': Table,
    'K-Live': Live,
    'K-Transition': Transition,
  },
  data() {
    return {
      currentYear: '',
      orgid: 1009,
      isMobile: false, //是否是移动端
      mobileWidth: 1920, //移动端宽度
      mobileHeight: 1080, //移动端高度
      currentDate: '',
      currentWeathre: {},
      //滚动参数
      srcollDelay: 2000, //滚动间隔毫秒
      updateTime: 600000, //更新数据时间毫秒
      updating: false, //数据更新中
      //监控
      live: {
        isShow: false,
        tabObj: {
          list: ['实时监控', '溯源记录', '栏位明细'],
          index: 1
        }
      },
      //组织信息
      orgInfo: {},
      //设备信息
      isLoding: false,
      device: [], //列表
      deviceIndex: 0, //当前选中
      deviceRecord: [], //设备记录
      liveRecordSwiper: null,
      liveRecordInterval: null, //轮播定时器
      liveRecordIndex: 0, //开始播放索引
      liveRecordDelay: 2000, //轮播延迟
      liveIsPlay: false,
      //地图
      map: '',
      mapData: {
        site: {
          list: [
            {
              City: "广东省",
              Area: 21011,
              CropsId: 1,
              Latitude: "23.363044",
              Longitude: "116.149077"
            }
          ],
          city: [
            "广东省"
          ]
        },
        type: {
          1: {
            id: 1,
            sn: "B005",
            name: "清远鸡",
            area: 360,
            icon_url: "https://zlua.com:9292/pic/清远鸡备份_3.png",
            color: "#55CA6A"
          }
        }
      },
      //企业信息
      selectVal: '',
      currentBusinessData: {},
      currentBusinessId: null,
      tableObj: {
        column: [{
          key: 'id',
          name: 'OID编号',
          customStyle: {
            width: '40rem'
          }
        }, {
          key: 'name',
          name: '户名',
          customStyle: {
            width: '50rem'
          }
        }, {
          key: 'address',
          name: '场地',
        }, {
          key: 'area',
          name: '面积',
        }, {
          key: 'number',
          name: '数量',
        }, {
          key: 'type',
          name: '养殖方式',
        }],
        list: []
      },
      //库存信息
      stockTableObj: {
        column: [{
          key: 'id',
          name: 'OID编号',
          customStyle: {
            width: '40rem'
          }
        }, {
          key: 'name',
          name: '户名',
          customStyle: {
            width: '50rem'
          }
        }, {
          key: 'totalCount',
          name: '总数量',
        }, {
          key: 'count',
          name: '可出栏数量',
        }, {
          key: 'sold',
          name: '已出库',
        }],
        list: []
      },
      //售出记录
      soldDatas: {
        date: [],
        data: []
      },
      //栏位库存
      siteStock: {
        column: [{
          key: 'name',
          name: '名称'
        }, {
          key: 'ac_total',
          name: '总数量',
        }, {
          key: 'maturity_total',
          name: '可出栏数量',
        }, {
          key: 'ck_total',
          name: '已出库',
        }],
        list: []
      }
    }
  },
  created() {
    if (this.$route.query.orgid) {
      this.orgid = this.$route.query.orgid;
    }
    this.isMobile = this.isMobileDevice(); //是否为移动端
    this.initSize(); //初始化size
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    this.getDate(); //当前时间
    this.getCurrentWeathre(); //获取当前天气
    this.GetOrgData(); //获取组织详情
    this.currentYear = new Date().getFullYear(); //获取当前年份

    window.onresize = (e) => {
      window.addEventListener('resize', this.handleResize)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    if (!this.isMobile) {
      this.backStyle(); //canvas背景
    }

    self.loadBaiduMap(()=>{
      this.createMap(); //地图
    })
  },
  watch: {
    //打开/关闭溯源直播面板
    'live.isShow': {
      handler(nval) {
        this.liveIsPlay = false;
        if (nval) {
          this.getBusinessDeviceRecordList(); //获取设备记录
          this.getSiteStock(); //获取栏位库存
        }
      }
    },
    //溯源直播与记录切换
    'live.tabObj.index': {
      handler(nval) {
        this.liveIsPlay = false;
        if (nval === 0) { //等于直播
          this.getLiveUrl(); //获取直播链接
        }
      }
    },
    //设备切换
    deviceIndex: {
      handler(nval) {
        this.live.tabObj.index = 1;
        this.liveIsPlay = false;
      }
    },
    //当前企业id变化
    currentBusinessId: {
      handler(nval) {
        this.deviceIndex = 0;
        this.deviceRecord = [];
        this.tableObj.list.forEach(item => {
          if (item.id === nval) {
            this.currentBusinessData = item;
            this.selectVal = item.name;
            this.getWeekSold(); //更新出库数据
          }
        })
        this.getBusinessDeviceList(); //获取设备列表
      }
    },
    //直播记录播放/暂停
    liveIsPlay: {
      handler(nval) {
        clearInterval(this.liveRecordInterval);
        if (nval) { //等于播放时
          console.log(this.deviceRecord)
          this.liveRecordInterval = setInterval(() => {
            console.log('播放中：', this.liveRecordIndex);
            this.liveRecordSwiper.slideTo(this.liveRecordIndex);
            if (this.liveRecordIndex === 0) {
              this.liveRecordIndex = this.deviceRecord.length - 1;
            } else {
              this.liveRecordIndex--
            }
          }, this.liveRecordDelay)
        }
      }
    },
    //企业列表变化
    'tableObj.list': {
      handler(nval) {
        setTimeout(() => {
          this.updating = false;
          const that = this;
          $('.srcoll-box').each(function (index, element) {
            if (element.clientHeight >= element.firstChild.clientHeight) return;
            setTimeout(() => { //错开执行
              that.scrollAnimate($(this), element.clientHeight, element.firstChild.clientHeight, index);
            }, index * 500);
          })
        }, this.srcollDelay);
      }
    }
  },
  methods: {
    scrollAnimate(self, boxHeight, scrollHeight, index) {
      console.log('动画', this.updating ? '被拦截' : '执行中');
      if (this.updating) return; //刷新后拦截
      const num = this.tableObj.list.length; //企业总数
      const step = scrollHeight / num; //每个占比得到步长
      let srcollTop = self.scrollTop() + step;
      if (self.scrollTop() + boxHeight >= scrollHeight) {
        srcollTop = 0;
      }
      self.animate({ scrollTop: srcollTop }, 'slow');
      setTimeout(() => {
        this.scrollAnimate(self, boxHeight, scrollHeight);
      }, this.srcollDelay);
    },
    handleResize() {
      clearTimeout(this.throttle);
      this.throttle = setTimeout(() => {
        this.initSize();
      }, 500);
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    PreviewImgs() {
      this.$viewer.show();
      this.$viewer.update();
    },
    //当前时间
    getDate() {
      setTimeout(() => {
        this.getDate();
      }, 1000)
      this.currentDate = this.CurrentDateFun(true);
    },
    //获取当前天气
    getCurrentWeathre() {
      axios.get(this.GetServerUrl(1) + "getWeathre?city=441800").then((res) => {
        if (res.data.meta.infocode == '10000') {
          this.currentWeathre = res.data.meta.lives[0];
        }
      })
    },
    //获取
    getScreenDirection() {
      const winWidth = window.innerWidth;
      const winHeight = window.innerHeight;
      return winWidth > winHeight ? 'h' : 'v';
    },
    //尺寸自适应
    initSize() {
      const h = this.getScreenDirection() === 'h' ? window.innerWidth : window.innerHeight;
      this.mobileWidth = h * 1.7;
      this.mobileHeight = h;
      const winWidth = document.body.offsetWidth;
      const initSize = this.isMobile ? this.mobileWidth / 750 : winWidth / 750;
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = initSize + 'px';
    },
    selectChange(e) {
      this.currentBusinessId = e;
    },
    //创建地图
    createMap() {
      const obj = {
        1009: '英德清远鸡',
        1013: '全息种植'
      }
      const offsetX = obj[this.orgid].length * 6;
      this.map = new BMap.Map("map"); // 创建Map实例
      this.map.setMapType(BMAP_SATELLITE_MAP); //默认显示卫星地图
      var point = new BMap.Point(113.417422, 24.19405);
      const myIcon = new BMap.Icon('/static/images/map-icon.png', new BMap.Size(50, 30));
      var marker = new BMap.Marker(point, { icon: myIcon });
      var label = new BMap.Label(obj[this.orgid], {
        offset: new BMap.Size(-offsetX, 26)
      });
      label.setStyle({
        color: "black",
        border: '0px',
        fontSize: "12px",
        height: "20px",
        padding: "0 10px",
        lineHeight: "20px",
        fontFamily: "微软雅黑"
      });
      marker.setLabel(label);
      this.map.addOverlay(marker);
      this.map.centerAndZoom(point, 12); // 初始化地图,设置中心点坐标和地图级别
      this.map.addControl(new BMap.MapTypeControl()); //添加地图类型控件
      this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    },
    //获取组织信息
    GetOrgData() {
      const params = new FormData();
      params.append("id", this.orgid);
      axios.post(this.GetServerUrl(1) + "org_public", params).then((response) => {
        this.orgInfo = response.data.meta;
        const colors = ['cyan-color', 'orange-color', 'yellow-color', 'green-color', 'rose-color'];
        this.orgInfo.customize_data.map((item, index) => {
          item.color = colors[index];
          return item;
        })
        this.getBusinessList(); //获取子企业列表

        //实时更新数据
        this.updating = true;
        setTimeout(() => {
          this.GetOrgData();
        }, this.updateTime);

      }).catch(function (error) {
        console.log(error)
      })
    },
    //获取子企业列表
    getBusinessList() {
      const params = new FormData();
      params.append("id", this.orgid);
      axios.post(this.GetServerUrl(1) + "business_list_public_new", params).then((response) => {
        const datas = response.data.meta;
        const infoList = [], stockList = [], customizeObj = {};
        let totalCount = 0, matureCount = 0, soldCount = 0;
        const markers = [];
        datas.forEach(item => {
          let customize_data = {};
          if (item.customize_data) {
            customize_data = JSON.parse(item.customize_data);
            customize_data && customize_data.forEach(value => {
              customizeObj[value.key] = value.value;
            })
          }

          const maturity = item.maturity_total - item.ck_total - item.zf_total; //可出栏数量
          totalCount += parseFloat(item.ac_total) || 0;
          matureCount += parseFloat(maturity) || 0;
          soldCount += parseFloat(item.ck_total) || 0;

          //企业信息
          infoList.push({
            id: item.rootid,
            name: item.name,
            address: customizeObj['场地'] || '-',
            area: customizeObj['面积'] || '-',
            number: customizeObj['数量'] || '-',
            type: customizeObj['养殖方式'] || '-'
          });

          //库存信息
          stockList.push({
            id: item.rootid,
            name: item.name,
            totalCount: item.ac_total || 0,
            count: maturity || 0,
            sold: item.ck_total || 0
          })

          //创建地图标记
          item.lon_lat && this.createMarker({
            id: item.rootid,
            name: item.name,
            data: item.lon_lat
          });
        });

        //组织信息
        this.orgInfo.customize_data.push(...[{
          color: 'yellow-color',
          key: '总数(只)',
          value: totalCount
        }, {
          color: 'green-color',
          key: '可出栏数(只)',
          value: matureCount
        }, {
          color: 'green-color',
          key: '已出库(只)',
          value: soldCount
        }]);
        this.tableObj.list = infoList;
        this.stockTableObj.list = stockList;
        this.currentBusinessId = datas[0].rootid; //当前企业id
      }).catch((error) => {
        console.log(error);
      })
    },
    //获取一周内的售出记录
    getWeekSold() {
      this.soldDatas = { date: [], data: [] }; //初始化数据
      const params = new FormData();
      params.append("id", this.currentBusinessId);
      const dateArray = this.getPreviousDaysDates(7);
      axios.post(this.GetServerUrl(1) + "get_week_sold", params).then((response) => {
        const datas = response.data.meta;
        dateArray.forEach(item => {
          let total = 0;
          datas.forEach(val => {
            if (val.date == item) {
              total = val.total;
            }
          })
          this.soldDatas.date.push(item.replace(new RegExp(this.currentYear + '-'), ''));
          this.soldDatas.data.push(total);
          this.soldChart(); //售出数据
        })
      }).catch((error) => {
        dateArray.forEach(item => {
          let total = 0;
          this.soldDatas.date.push(item.replace(new RegExp(this.currentYear + '-'), ''));
          this.soldDatas.data.push(total);
          this.soldChart(); //售出数据
        })
      })
    },
    //获取企业栏位库存
    getSiteStock() {
      this.siteStock.list = [];
      const params = new FormData();
      params.append("id", this.currentBusinessId);
      axios.post(this.GetServerUrl(1) + "get_site_stock", params).then((response) => {
        this.siteStock.list = response.data.meta.map(item => {
          const maturity = item.maturity_total - item.ck_total - item.zf_total; //可出栏数量
          return {
            id: item.rootid,
            name: item.name,
            ac_total: item.ac_total || 0,
            maturity_total: maturity || 0,
            ck_total: item.ck_total || 0
          }
        })
      }).catch((error) => {
        console.log(error);
      })
    },
    //获取设备列表
    getBusinessDeviceList(business) {
      this.device = [];
      const params = new FormData();
      params.append("id", this.currentBusinessId);
      params.append("no_page", true);
      axios.post(this.GetServerUrl(1) + "device_list_condition_public", params).then((response) => {
        const datas = response.data.meta;
        this.device = datas.map((item, index) => {
          item.active = index === 0 ? true : false;
          if (item.customize_data) {
            item.customize_data = JSON.parse(item.customize_data);
          }
          return item;
        })
      }).catch((error) => {
        console.log(error);
      })
    },
    //获取设备记录
    getBusinessDeviceRecordList() {
      if(!this.device.length) return;
      this.isLoding = true;
      this.deviceRecord = [];
      const params = new FormData();
      params.append("id", this.currentBusinessId);
      params.append("device_id", this.device[this.deviceIndex].device_id);
      params.append("no_page", true);
      axios.post(this.GetServerUrl(1) + "device_record_list_condition_public", params).then((response) => {
        this.isLoding = false;
        const datas = response.data.meta;
        this.deviceRecord = datas;

        setTimeout(() => {
          this.liveRecordSwiper = new Swiper('.swiper-container', {
            effect: 'fade',
            simulateTouch: false, //禁止拖动
          })
          this.liveRecordIndex = this.deviceRecord.length - 1; //当前开始索引
        }, 500);

      }).catch((error) => {
        this.isLoding = false;
        console.log(error);
      })
    },
    //获取直播链接
    getLiveUrl() {
      if (this.device[this.deviceIndex].liveUrl) return; //直播链接以获取
      this.isLoding = true;
      const params = new FormData();
      params.append("id", this.currentBusinessId);
      params.append("device_id", this.device[this.deviceIndex].device_id);
      axios.post(this.GetServerUrl(1) + "get_live_url_public", params).then((response) => {
        this.isLoding = false;
        const datas = response.data.meta;
        this.device[this.deviceIndex].key = datas.key;
        this.device[this.deviceIndex].url = datas.url;
      }).catch((error) => {
        this.isLoding = false;
        console.log(error);
      })
    },
    //出库信息图表
    soldChart() {
      const sold = echarts.init(document.getElementById('sold'));
      sold.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: 'rgba(237,45,45,.8)'
            }
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {
              iconStyle: {
                borderColor: '#59e3e8'
              }
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(76,207,254,0.6)']
              }
            },
            data: this.soldDatas.date
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: ['rgba(76,207,254,0.6)']
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(15, 84, 155, 0.3)'
              }
            }
          }
        ],
        series: [
          {
            name: '出库量',
            type: 'line',
            stack: 'Total',
            itemStyle: {
              color: '#59e3e8'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#094073'
                },
                {
                  offset: 1,
                  color: 'rgba(0, 43, 84, 0.9)'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: this.soldDatas.data
          }
        ]
      });
    },
    //创建地图标记
    createMarker({ id, name, data }) {
      const ll = data.split(",");
      const point = new BMap.Point(ll[0], ll[1]);
      const marker = new BMap.Marker(point);
      const left = name.length * 6;
      const label = new BMap.Label(name, {
        offset: new BMap.Size('-' + left, 26)
      });
      label.setStyle({
        color: "black",
        border: '0px',
        fontSize: "12px",
        height: "20px",
        padding: "0 10px",
        lineHeight: "20px",
        fontFamily: "微软雅黑"
      });
      marker.id = id;
      marker.setLabel(label);
      this.map.addOverlay(marker);
      marker.addEventListener("click", (e) => {
        this.currentBusinessId = e.currentTarget.id;
      });
    },
    //表格行内容点击
    async itemClickHandle(item){
      this.currentBusinessId = item.id;
      // this.live.tabObj.index = 2;
      // this.live.isShow = true;
      
      // //等待设备加载完成，加载抓拍记录
      // const res = await this.taskWait(()=>{
      //   return this.device.length;
      // })
      // if(res){
      //   this.getBusinessDeviceRecordList(); //获取设备拍照记录
      // }
    },
    //弹出层tab导航点击
    propsTabsClick(index){
      if(index === this.live.tabObj.index) return;
      this.live.tabObj.index = index;
    },
    /**
     * 传入天数获取日期数组
     * @param {*} task //执行任务：函数
     * @param {*} duration //任务持续时长（秒）
     * @param {*} delay  //任务执行间隔（毫秒）
     */
    taskWait (task, duration = 5, delay = 200){
      return new Promise((resolve, reject)=>{
        let t = 0;
        const interval = setInterval(() => {
          t += delay * 0.001;
          this.log('任务等待中:', t);
          if(t >= duration || task()){ //超时或者任务完成
            clearInterval(interval);
            resolve(task()?true: false); //完成返回true、超时返回false
          }
        }, delay);
      })
    },
    //canvas背景
    backStyle() {
      const canvas = document.getElementById('BackCanvas');
      document.body.classList.add('k-select');
      var ctx = canvas.getContext('2d')
      canvas.width = $(window).width();
      canvas.height = $(window).height();
      ctx.lineWidth = .3;
      ctx.strokeStyle = (new Color(150)).style;

      var mousePosition = {
        x: 30 * canvas.width / 100,
        y: 30 * canvas.height / 100
      };

      var dots = {
        nb: 200,
        distance: 70,
        d_radius: 100,
        array: []
      };

      function colorValue(min) {
        return Math.floor(Math.random() * 255 + min);
      }

      function createColorStyle(r, g, b) {
        return 'rgba(' + r + ',' + g + ',' + b + ', 0.8)';
      }

      function mixComponents(comp1, weight1, comp2, weight2) {
        return (comp1 * weight1 + comp2 * weight2) / (weight1 + weight2);
      }

      function averageColorStyles(dot1, dot2) {
        var color1 = dot1.color,
          color2 = dot2.color;

        var r = mixComponents(color1.r, dot1.radius, color2.r, dot2.radius),
          g = mixComponents(color1.g, dot1.radius, color2.g, dot2.radius),
          b = mixComponents(color1.b, dot1.radius, color2.b, dot2.radius);
        return createColorStyle(Math.floor(r), Math.floor(g), Math.floor(b));
      }

      function Color(min) {
        min = min || 0;
        this.r = colorValue(min);
        this.g = colorValue(min);
        this.b = colorValue(min);
        this.style = createColorStyle(this.r, this.g, this.b);
      }

      function Dot() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;

        this.vx = -.5 + Math.random();
        this.vy = -.5 + Math.random();

        this.radius = Math.random() * 2;

        this.color = new Color();
      }

      Dot.prototype = {
        draw: function () {
          ctx.beginPath();
          ctx.fillStyle = this.color.style;
          ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
          ctx.fill();
        }
      };

      function createDots() {
        for (var i = 0; i < dots.nb; i++) {
          dots.array.push(new Dot());
        }
      }

      function moveDots() {
        for (var i = 0; i < dots.nb; i++) {

          var dot = dots.array[i];

          if (dot.y < 0 || dot.y > canvas.height) {
            dot.vx = dot.vx;
            dot.vy = -dot.vy;
          } else if (dot.x < 0 || dot.x > canvas.width) {
            dot.vx = -dot.vx;
            dot.vy = dot.vy;
          }
          dot.x += dot.vx;
          dot.y += dot.vy;
        }
      }

      function connectDots() {
        for (var i = 0; i < dots.nb; i++) {
          for (var j = 0; j < dots.nb; j++) {
            var i_dot = dots.array[i];
            var j_dot = dots.array[j];

            if ((i_dot.x - j_dot.x) < dots.distance && (i_dot.y - j_dot.y) < dots.distance && (i_dot.x - j_dot.x) > -
              dots.distance && (i_dot.y - j_dot.y) > -dots.distance) {
              if ((i_dot.x - mousePosition.x) < dots.d_radius && (i_dot.y - mousePosition.y) < dots.d_radius && (i_dot
                .x - mousePosition.x) > -dots.d_radius && (i_dot.y - mousePosition.y) > -dots.d_radius) {
                ctx.beginPath();
                ctx.strokeStyle = averageColorStyles(i_dot, j_dot);
                ctx.moveTo(i_dot.x, i_dot.y);
                ctx.lineTo(j_dot.x, j_dot.y);
                ctx.stroke();
                ctx.closePath();
              }
            }
          }
        }
      }

      function drawDots() {
        for (var i = 0; i < dots.nb; i++) {
          var dot = dots.array[i];
          dot.draw();
        }
      }

      function animateDots() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        moveDots();
        connectDots();
        drawDots();

        requestAnimationFrame(animateDots);
      }

      $('canvas').on('mousemove', function (e) {
        mousePosition.x = e.pageX;
        mousePosition.y = e.pageY;
      });

      $('canvas').on('mouseleave', function (e) {
        mousePosition.x = canvas.width / 2;
        mousePosition.y = canvas.height / 2;
      });

      createDots();
      requestAnimationFrame(animateDots);
    }
  }
}
</script>
<style>
.k-select {
  .el-select-dropdown {
    background-color: #01264e !important;
    border: 1px solid #174c8b !important;
  }

  .el-select-dropdown__item {
    color: white !important;
    font-size: 6.5rem !important;
  }

  .el-select-dropdown__item.selected {
    color: #24e9ea !important;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #013e6d !important;
  }

  .el-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #01264e !important;
  }

  .el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #174c8b !important;
  }

  .el-dropdown {
    width: 100%;
    color: #24e9ea;
    font-size: 6.5rem;
    box-sizing: border-box;
  }

  .el-dropdown-link {
    padding-right: 5rem;
  }

  .el-dropdown-menu {
    background-color: #01264e;
    border: 1px solid #174c8b;
  }

  .el-dropdown-menu__item {
    color: white;
    font-size: 6.4rem;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #24e9ea;
    background-color: #013e6d;
  }

  .el-dropdown-menu__active {
    color: #24e9ea;
    background-color: #013e6d;
  }
}
</style>
<style scoped lang="scss">
$fontColor: #24e9ea;
$borderColor: #59e3e8;
$smallFontSize: 6rem;
$standardFontSize: 6.5rem;
$titleFontSize: 7rem;
$largeFontSize: 10rem;

@for $i from 1 through 20 {
  .gap#{$i} {
    gap: 1px * $i;
  }
}

$margin: top, right, bottom, left;

@each $i in $margin {
  @for $j from 1 through 20 {
    $key: str-slice($i, 1, 1);

    .m#{$key}#{$j} {
      margin-#{$i}: $j + rem !important;
    }
  }
}

.hover {
  &:hover {
    opacity: .95;
  }
}

.no-select {
  user-select: none;
}

.cyan-color {
  color: $fontColor;
}

.orange-color {
  color: #FF9411;
}

.yellow-color {
  color: #FFCB01;
}

.green-color {
  color: #55CA6B;
}

.rose-color {
  color: #D85A84;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.align-center {
  align-items: center;
}

.space-between {
  justify-content: space-between;
}


.overflow-hidden {
  overflow: hidden;
}

.one-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.absolute-box {
  position: absolute;
  left: 0;
  top: 0;
}

.full-box {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-sizing: border-box;
}

.full-img {
  width: 100%;
  height: 100%;
  display: block;
}

.object-fit-cover {
  object-fit: cover;
  // object-position: 0 0;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, .1);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom right, rgba(15, 84, 155, 0.9) 0%, #0f549b 100%);
  border-radius: 5px;
}

.srcoll-auto {
  overflow: auto;
}

canvas {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: block;
  background-color: #011337;
}

.box {
  padding: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.map-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.product {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 5rem;
  box-sizing: border-box;

  img {
    width: 25px;
    height: 25px;
    display: block;
    margin: auto;
  }

  .title {
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
  }
}

header {
  height: 45rem;
  color: $fontColor;
  position: relative;

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-size: 90% 70%;
    background-position: 50% 60%;
    background-image: url('/public/static/images/header.png');
    opacity: 0.9;
  }

  .title {
    font-weight: 600;
    font-size: 13rem;
    // line-height: 40rem;
    text-align: center;
    background-image: -webkit-linear-gradient(bottom, $fontColor 50%, #FFFFFF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .address {
    top: 9.5rem;
    left: 95rem;
    font-size: 7rem;
    position: absolute;
  }

  .date {
    top: 9.5rem;
    right: 50rem;
    font-size: 7rem;
    position: absolute;
  }
}

.content {
  height: calc(100% - 45rem);
}

.container {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;

  .left {
    width: 28%;
  }

  .middle {
    width: 44%;
  }

  .right {
    width: 28%;
  }
}

.style-Illidan {
  display: flex;

  .item {
    margin: auto;
  }

  .title {
    font-size: $standardFontSize;
  }

  .text {
    display: table;

    .number {
      font-size: $largeFontSize;
      font-weight: 600;
    }

    .value {
      font-size: 6rem;
    }

    .unit {
      font-size: $standardFontSize;
    }
  }

  .item-center {
    text-align: center;

    .text {
      margin: auto;
    }
  }
}

/* 导航头 */
.main-head {
  color: $fontColor;
  padding-left: 9rem;
  line-height: 20rem;
  position: relative;
  font-size: $standardFontSize;
  background-color: rgba($color: #063a6a, $alpha: 1);

  &::before {
    width: 2rem;
    height: 100%;
    display: block;
    content: '';
    left: 0;
    top: 0;
    position: absolute;
    background-color: #0f549b;
  }

  :deep .el-input__inner {
    border: none;
    color: $fontColor;
    font-size: $standardFontSize;
    padding-left: 3rem;
    background-color: transparent;

    &::placeholder {
      color: $fontColor;
    }
  }

  :deep .el-select__caret {
    color: $fontColor !important;
  }
}

.nobg {
  background-color: transparent;
}

/* 内容容器 */
%corner {
  width: 10px;
  height: 10px;
  display: block;
  content: '';
  position: absolute;
  border: 1px solid $borderColor;
}

.main-box {
  position: relative;
  border: 1px solid rgba($color: #0f549b, $alpha: 0.9);
  background-color: rgba($color: #002b54, $alpha: .9);

  &::before {
    @extend %corner;
    left: 0;
    top: 0;
    border-right: 0;
    border-bottom: 0;
  }

  &::after {
    @extend %corner;
    right: 0;
    top: 0;
    border-left: 0;
    border-bottom: 0;
  }

  .main-content {
    padding: 5px;
    width: 100%;
    height: 100%;
    color: white;
    box-sizing: border-box;

    &::before {
      @extend %corner;
      left: 0;
      bottom: 0;
      border-top: 0;
      border-right: 0;
    }

    &::after {
      @extend %corner;
      right: 0;
      bottom: 0;
      border-top: 0;
      border-left: 0;
    }
  }
}

.video-box {
  position: relative;

  .video-play-icon {
    width: 25rem;
    height: 25rem;
    position: absolute;
    top: 50%;
    left: 50%;
    cursor: pointer;
    z-index: 9;
    transform: translate(-50%, -50%);

    &:hover {
      opacity: .9;
    }
  }
}

.btn-array {
  display: flex;
  flex-direction: row;
  width: fit-content;

  .btn {
    padding: 5rem 7rem;
    border-radius: 2rem;
    cursor: pointer;
    min-width: 22rem;
    text-align: center;
    opacity: .8;
    background-color: #053664;

    &:hover {
      opacity: 1;
      background-color: #094073;
    }
  }

  .btn-active {
    opacity: 1;
    background-color: #094073;
  }
}

#map {
  opacity: 0.7;

  :deep .anchorBL {
    display: none;
  }
}


/* 监控弹出层 */
.dialog-head {
  color: $fontColor;
  position: relative;
  justify-content: center;

  .dialog-title {
    font-size: 8.5rem;
    width: 180rem;
    text-align: center;
    background-image: url('/public/static/images/live-head.png');
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 100% 100%;
  }

  .close-icon {
    position: absolute;
    right: 10rem;
    top: 50%;
    font-size: 9rem;
    cursor: pointer;
    transform: translate(0, -50%);

    &:hover {
      opacity: 0.9;
    }
  }
}

.dialog-main {
  padding: 10rem 15rem 15rem 15rem;
  box-sizing: border-box;
  height: calc(100% - 7vh);
  gap: 3rem;
  font-size: $smallFontSize;

  .left {
    width: 80rem;
    border: 2px solid #174c8b;

    .head {
      color: $fontColor;
      text-align: center;
      padding: 7rem 0;
      border-bottom: 2px solid;
      font-size: $titleFontSize;
      border-image: linear-gradient(270deg, rgba(51, 131, 191, 0), #2467a4, rgba(23, 76, 139, 0)) 2 2;
    }

    .main {
      color: rgba($color: white, $alpha: .6);

      .row {
        padding: 3rem 0;
        padding-left: 20rem;
        position: relative;
        margin-top: 5rem;
        cursor: pointer;

        li {
          padding: 1rem 0;
        }

        .icon {
          position: absolute;
          left: 5rem;
          top: 50%;
          font-size: 9rem;
          transform: translate(0%, -50%);
        }
      }

      .active {
        color: $fontColor;
        background-color: #164e82;
      }
    }
  }

  .right {
    height: 100%;
    box-sizing: border-box;
    width: calc(100% - 80rem);
    border: 2px solid #174c8b;

    .main-head {
      padding: 0rem 0 0rem 8rem;

      &::before {
        background-color: $fontColor;
      }
    }

    .head {
      line-height: 23rem;
      padding-left: 10rem;
      margin: 10rem;
      color: rgba($color: white, $alpha: .6);
      background-size: 100% 100%;
      background-image: url('/public/static/images/live-r-head.png');

      li {
        cursor: pointer;
        font-size: $titleFontSize * 1.05;
        padding: 0 15rem;
      }

      .active {
        color: $fontColor;
      }
    }

    .main {
      padding: 0 10rem;
      padding-bottom: 10rem;
      overflow-y: auto;
      box-sizing: border-box;
      height: calc(100% - 45rem);
      background: #01264e;

      .player-box {
        height: 45vh;
        padding-bottom: 5rem;
      }

      .list {
        gap: 5rem;
        margin-top: 3rem;
        flex-wrap: wrap;

        .row {
          width: 110rem;
          margin-top: 5rem;
          color: $fontColor;

          img {
            display: block;
            width: 100%;
            margin-top: 5rem;
          }
        }
      }
    }
  }
}
</style>
